import { Injectable } from '@angular/core';
import { AppState } from '@get/store/configs/reducers';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GeneratedComposantGroupeService } from './composant-groupe-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ComposantGroupeService extends GeneratedComposantGroupeService {
  constructor(store$: Store<AppState>, actions$: Actions) {
    super(store$, actions$);
  }
}
